import { useNavigate, useLocation } from '@reach/router';
import { useState, useEffect } from 'react';

import { stringIsNumber, scrollToTop } from '../../utils';

const usePagination = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const page = new URLSearchParams(location.search).get('page') || '';

  const [activePage, setActivePage] = useState(
    stringIsNumber(page) ? parseInt(page, 10) : 1
  );

  const isFirstPage = activePage === 1;

  const changePage = (page: $TSFixMe) => {
    scrollToTop();
    navigate(`${location.pathname}?page=${page}`);
  };

  useEffect(() => {
    if (stringIsNumber(page)) {
      setActivePage(parseInt(page, 10));
    }
  }, [page]);

  return { activePage, changePage, isFirstPage };
};
export { usePagination };
